import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  GroupCustomSegment,
  GroupHiddenCustomSegment,
} from '@libs/src/models/group.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-group-segments-chips',
  standalone: false,
  templateUrl: './group-segments-chips.component.html',
})
export class GroupSegmentsChipsComponent {
  @Input() customSegment: GroupCustomSegment | GroupHiddenCustomSegment;
  @Input() isPrivateSegment: boolean;

  get isMultiSelection() {
    return 'multi' === this.customSegment.selection_type;
  }

  get privacySettings(): Partial<GroupHiddenCustomSegment['privacy_settings']> {
    return this.customSegment.privacy_settings;
  }
}
